import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AddModalButton, CloseButton, ToastScreen } from 'components';
import { LoadServices } from 'store';
import { billingDetailsStyle } from '../../../../fragments/billing/billingDetails/core';

export const ReceivablesInvoice = ({ res, handleClose, loadIds }) => {
  const {  customersList } = useSelector((state) => ({
    customersList: state.customers.customersList,
  }));
  const classes = billingDetailsStyle()
  const history = useHistory();
  const info = history?.location?.state;
  const [loadSend, setLoadSend] = useState(false);
  const currentCustomer = customersList?.customers?.find((i) => i?.id === info?.customer)
  const handleSendEmail = async () => {
    setLoadSend(true);
    try {
      await LoadServices.sendReceivablesInvoiceEmail({
        customerId: info?.customer,
        loadIds: loadIds,
        document: res,
      });
      toast(
        <ToastScreen
          type={'success'}
          text={'Invoice was successfully sent to the email!'}
        />,
      );
      handleClose()
      setLoadSend(false);
    } catch (e) {
      toast(
        <ToastScreen
          type={'error'}
          text={e?.response?.data?.message || 'Something went wrong!'}
        />,
      );
      setLoadSend(false);
    }
  };

  return(
    <div>
      <div style={{ overflow: 'scroll', height: '700px' }} className={classes.paperWrapper}>
        <div className='space-between' style={{marginBottom: 14}}>
          <div/>
          <div>
            <p className={classes.customerBillingEmail}>
              The Document will be sent to{" "}
              {currentCustomer?.billingEmail}
            </p>
          </div>
          <div>
            <CloseButton handleCLic={handleClose} />
          </div>
        </div>
        <div style={{ height: '702px', overflow: 'scroll' }}>
          <object
            style={{ overflow: 'hidden' }}
            data={res?.url}
            width="100%" height="100%"
          >
          </object>
        </div>
      </div>
      <div className={classes.paperFooter}>
        <div style={{ display: 'flex' }}>
          <AddModalButton
            loading={loadSend}
            styles={{ width: '238px' }}
            handleClick={handleSendEmail}
            text={'Send'}
          />
        </div>
      </div>
    </div>
  )
}